import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { waLink, WHATSAPP_DISPLAY } from '../data/whatsapp';

const { FiArrowUpRight, FiInstagram } = FiIcons;
const { FaWhatsapp } = FaIcons;

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <a href="#top" className="brand footer-brand" aria-label="Forge Fitness home">
          <span className="brand-mark">F<span>.</span></span>
          <span className="brand-name">FORGE <small>FITNESS CLUB</small></span>
        </a>
        <p>Made for movement.<br />Built around real life.</p>
        <div className="footer-social">
          <a href={waLink()} target="_blank" rel="noreferrer" aria-label="WhatsApp"><SafeIcon icon={FaWhatsapp} /></a>
          <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" aria-label="Instagram"><SafeIcon icon={FiInstagram} /></a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2025 Forge Fitness Club</span>
        <span>{WHATSAPP_DISPLAY}</span>
        <a href={waLink('Hello! I have a question about Forge Fitness.')} target="_blank" rel="noreferrer">Say hello <SafeIcon icon={FiArrowUpRight} /></a>
      </div>
    </footer>
  );
}
export default Footer;
